export default "__VITE_ASSET__j2KV0L32__"